<div class="mt-2" [id]="wrapId">
  <label>{{ 'sigPad.signature'| translate }}:</label>
  <signature-pad style="background: white;justify-content: flex-start"
                 *ngIf="initialized"
                 #signature
                 [options]="signaturePadOptions"
                 (drawEnd)="drawComplete($event)">
  </signature-pad>
  <div class="d-flex mt-2" style="gap:10px" *ngIf="signature">
    <button class="btn btn-secondary" (click)="clearSignature()">
      <i class="fas fa-times-circle"></i>
      {{ 'sigPad.retrySignature' | translate }}
    </button>
  </div>
</div>
